/* global gtag */

import styled from "styled-components";
import { GoCheckCircleFill } from "react-icons/go";
import {Button, Heading} from "@chakra-ui/react";
import {NavLink, useSearchParams} from "react-router";
import {useEffect} from "react";

const Container = styled.div`
  padding: 150px 0;
  max-width: 550px;
  margin: auto;
  display: flex;
  align-self: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 30px;
`;
const SuccessIcon = styled(GoCheckCircleFill)`
  margin: auto;
`;
const StyledButton = styled(Button)`
  font-size: 18px;
  padding: 24px;
  width: 100%;
`;

function gtag_report_conversion(sessionId) {
    try {
        // Wysyłanie zdarzenia konwersji do Google Ads
        gtag('event', 'conversion', {
            'send_to': 'AW-16905300637/RyltCM6dsqUaEJ3Vif0-',
            'value': 1.0,
            'transaction_id': sessionId,
        });
    } catch(error) {
        console.error(error)
    }
}

function PaymentSuccess() {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("session_id");

    useEffect(() => {
        if (sessionId) {
            // Wywołanie funkcji gtag_report_conversion, która przekieruje użytkownika po wykonaniu zdarzenia
            gtag_report_conversion(sessionId);
        }
    }, [sessionId])

    return <Container>
        <SuccessIcon size={160} color="#48BB78" />
        <Heading size="4xl">Dziękujemy za Twoje zamówienie!</Heading>
        <p>Na podany adres e-mail wyślemy wiadomość zawierającą szczegółowe informacje o zakupie.</p>
        <p>Jeśli masz jakiekolwiek pytania jesteśmy do Twojej dyspozycji.</p>
        <NavLink to="/" >
            <StyledButton rounded="full">Rozumiem</StyledButton>
        </NavLink>
    </Container>
}

export default PaymentSuccess;
